<template>
  <div class="page">
      <van-panel class="panel-info">
        <div class="content">
          <!--    用户信息      -->
          <div class="row" style="margin-top: 0">
            <van-cell class="cell-padding" size="large" center >
              <div class="user-item">
                <div class="left align-center">
                  <div class="user_head">
                    <van-image
                        round
                        width="60px"
                        height="60px"
                        :src="model.headImgUrl">
                    </van-image>
                      <div class="avatarFrame" v-if="model.levelFrameUrl">
                      <img width="80px" height="80px" :src="model.levelFrameUrl"/>
                    </div>
                    <van-tag v-if="model.levelName" class="level" type="primary" round size="medium">{{ model.levelName }}</van-tag>
                  </div>
                  <div class="padding-left-sm">
                    <!-- id 已关注 黑名单 -->
                    <div class="left-sm-tag">
                      <van-tag plain type="primary">ID：{{ model.userId }}</van-tag>
                      <van-tag v-if="model.subscribe == 1" type="success">已关注</van-tag>
                      <van-tag v-else plain>未关注</van-tag>
                      <van-tag v-if="$hasFeature('user_violation_share') && model.userViolationSignList && model.userViolationSignList.length > 0" plain color="#91d5ff" @click.stop.prevent="showViolation = true" >
                        <a>{{ model.userViolationSignList.length }}条违规</a>
                      </van-tag>
                      <van-tag v-if="model.isBlacklist" type="default" color="black" @click="lookBlack">黑名单</van-tag>
                    </div>
                    <!-- 用户昵称 1条违规 -->
                    <div>
                      <span>{{ model.userName }}</span>
                    </div>
                    <!-- 推荐人：xxx -->
                    <div v-if="model.distributorName" class="recommend">
                      推荐人：{{ model.distributorName }}
                    </div>
                  </div>
                </div>
                <div class="right">
                </div>
              </div>
            </van-cell>
          </div>
          <div class="row">
            <span class="label">实名状态</span>
            <span class="value" v-if="model.isVerified">
              <span style="margin-right: 15px">已实名</span>
              <template v-if="$hasRole('super_admin')||$AdminPermission.userManagePermission.includes('require_verify') && model.isVerified">
              <a class="text-blue" @click="clearVerify">清除实名</a>
              </template>
            </span>
            <span class="value" v-else>未实名</span>
          </div>
          <div class="row">
            <span class="label">是否实名</span>
            <template v-if="$hasRole('super_admin') || $AdminPermission.userManagePermission.includes('require_verify')">
              <div class="flex align-center"
                   @click="openPicker(requireVerifyColumn,(value)=>{updateRequireVerify(model.userId,requireVerifyMap[value])},()=>{})">
                <template v-if="model.requireVerify === true"><span>需要</span></template>
                <template v-else-if="model.requireVerify === false"><span>不需要</span></template>
                <template v-else><span>跟随店铺设置</span></template>
                <van-icon name="arrow-down"/>
              </div>
            </template>
            <template v-else>
              <div class="flex align-center">
                <template v-if="model.requireVerify === true"><span>需要</span></template>
                <template v-else-if="model.requireVerify === false"><span>不需要</span></template>
                <template v-else><span>跟随店铺设置</span></template>
              </div>
            </template>
          </div>
          <div class="row" v-if="$hasRole('super_admin') || $AdminPermission.userManageVisibleInfo.includes('relation')">
            <span class="label">联系方式</span>
            <span class="value" >
              <a class="text-blue" v-if="contactWay.mobile||(contactWay.wechatIds && contactWay.wechatIds.length>0)" @click="contactWay.show=true">点击查看</a>
              <span v-else>暂无</span>
            </span>
          </div>
          <div class="row" v-if="$hasRole('super_admin') || $AdminPermission.userManageVisibleInfo.includes('balance')">
            <span class="label">余额</span>
            <span class="value">￥{{formatPrice(model.balance)}}</span>
          </div>
          <div class="row">
            <span class="label">订单数</span>
            <span class="value">{{model.orderCount}}</span>
          </div>
          <div class="row">
            <span class="label">笔单价</span>
            <span class="value" v-if="model.sumTotalAmount != 0 && model.orderCount != 0">￥{{computeAveragePrice(model.sumTotalAmount, model.orderCount)}}</span>
            <span class="value" v-else>￥0</span>
          </div>
          <div class="row">
            <span class="label">订单总额</span>
            <span class="value">￥{{formatPrice(model.sumTotalAmount)}}</span>
          </div>
          <div class="row">
            <span class="label">注册时间</span>
            <span class="value">{{formatDate(model.createTime, 'YYYY-MM-DD HH:mm:ss')}}</span>
          </div>
          <div class="row">
            <span class="label">首次下单</span>
            <span class="value">{{formatDate(model.firstOrderTime, 'YYYY-MM-DD HH:mm:ss')}}</span>
          </div>
          <div class="row">
            <span class="label">最后下单</span>
            <span class="value">{{formatDate(model.lastOrderTime, 'YYYY-MM-DD HH:mm:ss')}}</span>
          </div>
          <div class="row" v-if="$hasFeature('user_violation_share') && model.userViolationSignList && model.userViolationSignList.length > 0" >
            <span class="label">违规记录</span><span class="value">
            <span class="text-blue">{{model.userViolationSignList.length}}</span>条
            <a class="text-blue" @click="showViolation = true">查看</a>
          </span>
          </div>
        </div>
        <div v-if="$hasFeature('user_violation_share') && ($hasRole('super_admin') || $AdminPermission.userManagePermission.includes('violation'))">
          <van-button v-if="model.isViolation" type="warning" size="large" @click="cancelViolation">取消标记</van-button>
          <van-button v-else type="warning" size="large" @click="markViolation.show = true">标记违规</van-button>
        </div>


        <van-button class="button-margin" type="default" color="#969799" size="large"
                    v-if="$hasRole('super_admin') || $AdminPermission.userManagePermission.includes('blacklist')"
                    @click="handleBlacklist(model.isBlacklist)">
          {{ model.isBlacklist ? '取消黑名单' : '加入黑名单' }}
        </van-button>

      </van-panel>
      <van-popup v-model="picker.show" position="bottom" round>
        <van-picker
            :columns="picker.columns"
            show-toolbar
            @cancel="onPickerCancel"
            @confirm="onPickerConfirm"
        />
      </van-popup>
      <!--  查看违规内容  -->
      <ViolationSelect :showViolation="showViolation" :userViolationSignList="model.userViolationSignList"
                       @changeShowViolation="changeShowViolation"></ViolationSelect>

    <!--  标记违规  -->
    <van-dialog v-model="markViolation.show" show-cancel-button title="标记违规" class="mark-violation" @confirm="confirmViolation"
                v-if="$hasRole('super_admin')||$AdminPermission.userManagePermission.includes('violation')">
      <div>
        <div show-icon class="warning">
          <van-icon name="warning" color="orange" style="margin: 5px" />
          <div>
            1)标记功能仅限标记用户使用，不可用于标记店员;<br/>
            2)标记内容将对所有店铺进行公开，请慎重添加;<br/>
            3)若出现恶意标记用户、标记店员或提交内容与违规类型不相符的情况，将剔除相关标记，情节严重的将取消相关店铺的标记功能。
          </div>
        </div>
        <van-field
            :value="markViolation.remark"
            is-link
            clickable
            label="违规内容"
            placeholder="点击选择违规内容"
            readonly
            @click="openPicker(UserViolationTypeColumn,(value)=>{markViolation.remark = value})"
        />
        <div class="photo">
          <div>
            违规截图（{{this.markViolation.fileList.length}}/5）
          </div>
          <van-uploader
              v-model="markViolation.fileList"
              :max-count="5"
              style="margin: 10px"
              accept="image/*"
              class="image-uploader"
              multiple
              preview-size="80"
              upload-icon="plus"
              :after-read="violationAfterRead"/>
        </div>
      </div>
    </van-dialog>


    <van-dialog v-model="blackList.show" show-cancel-button title="确定要将用户加入黑名单吗？" class="mark-violation" @confirm="blackListUp">
      <div>
        <van-field v-model="blackList.blacklistContent" label="原因" maxlength="100" placeholder="最多输入100个字" show-word-limit type="textarea"/>
        <div class="photo">
          <div>
            上传图片（{{this.blackList.blacklistImgs.length}}/4）
          </div>
          <van-uploader
              v-model="blackList.blacklistImgs"
              :max-count="4"
              style="margin: 10px"
              accept="image/*"
              class="image-uploader"
              multiple
              preview-size="80"
              upload-icon="plus"
              :after-read="violationAfterRead"/>
        </div>
      </div>
    </van-dialog>

    <van-dialog class="lookBlack" v-model="blackLook.show">
      <div class="title">加入黑名单说明</div>
      <div class="line-title">备注</div>
      <div class="text">{{blackLook.blacklistContent}}</div>
      <div class="line-title">上传图片</div>
      <div v-if="blackLook.blacklistImgs.length > 0" class="img-box">
        <img v-for="(item,index) of blackLook.blacklistImgs" :key="index" :src="item" @click.stop.prevent="handleclickImg(blackLook.blacklistImgs,index)">
      </div>
    </van-dialog>

    <van-dialog v-model="contactWay.show" show-cancel-button title="联系方式" >
      <div show-icon style="line-height: 21px;justify-content: flex-start"  class="info">
        <van-icon name="warning" color="#2d8cf0" style="margin: 5px" />
        <div>多个微信号表示用户下单填写不同的微信号</div>
      </div>
      <div style="margin:0 20px;">
        <div class="contact-way" >
          <div style="width: 20%">手机号:</div>
          <div v-if="contactWay.mobile" style="line-height: 21px;color: #333">{{contactWay.mobile}}</div>
          <div v-else>-</div>
        </div>
        <div class="contact-way" >
          <div style="width: 20%">微信号:</div>
          <div class="wechat">
            <span v-if="contactWay.wechatIds">
              <div  v-for="(item,index) in contactWay.wechatIds" :key="index" >{{item}}</div>
            </span>
            <span v-else>-</span>
          </div>
        </div>
      </div>

    </van-dialog>

  </div>
</template>

<script>
import Vue from 'vue';
import { Panel, Cell, CellGroup, Button, Tag, Icon, Toast, Dialog, Field, ImagePreview, Uploader ,Popup ,Picker ,Image} from 'vant';
import Decimal from 'decimal.js';
import moment from 'moment';

import ViolationSelect from '@/components/common/violation-select'
import {
  updateBlacklist,
  updateRequireVerify,
  updateViolation,
  clearVerify,
  getUser,
  isPlaceAnOrder,
  queryBlacklist
} from "@/api/admin/user";
import _ from "lodash";

Vue.use(Panel)
    .use(Cell)
    .use(CellGroup)
    .use(Button)
    .use(Tag)
    .use(Icon)
    .use(Toast)
    .use(Dialog)
    .use(Field)
    .use(Uploader)
    .use(Popup)
    .use(Picker)
    .use(Image)

export default {
  name: 'admin-user-detail',
  components:{
    ViolationSelect
  },
  computed:{
    requireVerifyColumn() {
      return Object.keys(this.requireVerifyMap)
    },
    UserViolationTypeColumn() {
      return this.mapEnumToColumn(this.$store.state.UserViolationTypeEnum)
    },
  },
  data () {
    return {
      blackLook: {
        show: false,
        blacklistContent: null,
        blacklistImgs: []
      },
      model: null,
      showViolation: false,
      blackList: {
        show:false,
        blacklistContent: '',
        blacklistImgs: []
      },
      markViolation:{
        show:false,
        type:null,
        remark:null,
        fileList:[],
      },
      payAmount: null,
      msg: null,
      picker: {
        show: false,
        columns: [],
        onConfirm: null,
        onCancel: null
      },
      requireVerifyMap: {
        '需要实名': 'true',
        '无需实名': 'false',
        '跟随店铺设置': 'null',
      },
      contactWay:{
        show: false,
        mobile:null,
        wechatIds:[],
      }
    }
  },
  methods: {
    getPlaceAnOrder(){
      isPlaceAnOrder(this.model.userId).then(res=>{
        const data = res.data;
        if (data.code == 0){
          if (data.isPlaceAnOrder){
            this.markViolation.show = true;
          }else{
            Dialog.alert({
              title:  '标记违规失败',
              message: '当前用户未在此店铺下过单'
            })
          }
        }else{
          Dialog.alert({
            title:  '获取标记违规失败',
            message: data.message
          })
        }
      })
    },
    mapEnumToColumn(Enum) {
      return _.map(Enum.list(), (elem) => {
        return elem.label
      })
    },
    handleclickImg(photoUrls, index) {
      ImagePreview({
        images: photoUrls,
        startPosition: index,
      });
    },
    openPicker(columns, onConfirm,onCancel) {
      this.picker.columns = columns
      this.picker.onConfirm = onConfirm
      if(!onCancel){
        onCancel = () => {
          onConfirm(null)
        }
      }
      this.picker.onCancel = onCancel;
      this.picker.show = true
    },
    onPickerConfirm(value) {
      if (this.picker.onConfirm) {
        this.picker.onConfirm(value)
      }
      this.picker.show = false
    },
    onPickerCancel(value) {
      if (this.picker.onCancel) {
        this.picker.onCancel(value)
      }
      this.picker.show = false
    },
    // 修改用户是否需要实名认证
    updateRequireVerify(id, requireVerify) {
      Dialog.confirm({
        title: '提示',
        message:  '确认要修改吗？',
      }).then(() => {
        Toast.loading({
          mask: true,
          message: '请稍候...'
        })
        updateRequireVerify(id, requireVerify).then(res => {
          Toast.clear()
          const data = res.data
          if (data.code == 0) {
            this.loadData()
            Toast.success('修改成功')
          } else {
            Dialog.alert({
              title:  '修改失败',
              message: data.msg
            })
          }
        })
      }).catch(()=>{});
    },
    clearVerify() {
      Dialog.confirm({
        title: '提示',
        message:  '确定清除该用户的实名吗？',
      }).then(() => {
        Toast.loading({
          mask: true,
          message: '请稍候...'
        })
        clearVerify(this.model.userId).then(res => {
          Toast.clear()
          const data = res.data
          if (data.code == 0) {
            this.loadData()
            Toast.success('修改成功')
          } else {
            Dialog.alert({
              title:  '修改失败',
              message: data.msg
            })
          }
        })
      })
    },
    /** 处理黑名单 */
    handleBlacklist(isBlacklist) {
      if(isBlacklist){
        this.blackListUp()
      }else {
        this.blackList.show = true
      }
    },
    changeShowViolation(val){
      this.showViolation = val
    },
    /** 处理违规 */
    confirmViolation() {
      if(this.markViolation.remark == null || this.markViolation.remark == ''){
        return Toast.fail('请选择违规内容')
      }
      if (this.markViolation.remark) {
        this.markViolation.type = this._.find(this.$store.state.UserViolationTypeEnum.list(), (elem) => {
          return elem.label === this.markViolation.remark
        }).value;
      }
      if(this.markViolation.fileList.length === 0){
        return Toast.fail('至少上传一张图片')
      }
      if(this.markViolation.fileList.length > 5){
        return Toast.fail('最多上传五张图片')
      }
      Toast.loading({
        mask: true,
        message: '请稍后...'
      })
      updateViolation(this.model.userId, true, this.markViolation.type, JSON.stringify(this.markViolation.fileList)).then(res => {
        Toast.clear()
        const data = res.data
        if (data.code == 0) {
          this.markViolation.show = false
          this.markViolation.type = null
          this.markViolation.remark = null
          this.markViolation.fileList = []
          this.loadData()
          Toast.success('标记违规成功')
        } else {
          Dialog.alert({
            title: '标记违规失败',
            message: data.msg
          })
        }
      })
    },

    blackListUp() {
      Toast.loading({
        mask: true,
        message: '请稍后...'
      })
      updateBlacklist(this.model.userId, !this.model.isBlacklist, this.blackList.blacklistContent, JSON.stringify(this.blackList.blacklistImgs)).then(res => {
        Toast.clear()
        const data = res.data
        if (data.code == 0) {
          this.loadData()
          Toast.success('操作成功')
        } else {
          Dialog.alert({
            title: '操作失败',
            message: data.msg
          })
        }
      })
    },
    lookBlack(){
      Toast.loading({
        mask: true,
        message: '请稍后...'
      })
      queryBlacklist(this.model.userId).then(res => {
        Toast.clear()
        const data = res.data
        if (data.code == 0) {
          this.blackLook.blacklistContent = data.blacklistContent
          this.blackLook.blacklistImgs = data.blacklistImgs
          this.blackLook.show = true
        } else {
          Dialog.alert({
            title: '请求失败',
            message: data.msg
          })
        }
      })
    },
    cancelViolation(){
      Toast.loading({
        mask: true,
        message: '请稍后...'
      })
      updateViolation(this.model.userId, false).then(res => {
        Toast.clear()
        const data = res.data
        if (data.code == 0) {
          this.loadData()
          Toast.success('取消标记成功')
        } else {
          Dialog.alert({
            title: '取消标记失败',
            message: data.msg
          })
        }
      })
    },
    formatDate(date, format) {
      if (!date) {
        return '';
      }
      if (!format) {
        format = 'YYYY-MM-DD'
      }
      return moment(date).format(format);
    },
    formatPrice(price) {
      if (price != null) {
        return Decimal.div(price, 100).toString()
      }
      return ''
    },
    /** 计算笔单价 */
    computeAveragePrice(sumTotalAmount, orderCount) {
      if (sumTotalAmount != 0 && orderCount != 0) {
        return Decimal.div(Decimal.div(sumTotalAmount , orderCount), 100).toNumber().toFixed(2)
      }
      return ''
    },
    // 格式化时间差
    formatTimeDiff(start, end,status) {
      start = moment(start)
      end = moment(end)
      const diffSeconds = end.diff(start, 'seconds')
      if (status === 2 && diffSeconds < 1) {
        return '即将完成'
      }
      if (diffSeconds < 60) {
        return `${diffSeconds}秒`
      }
      const diffMinutes = end.diff(start, 'minutes')
      if (diffMinutes < 60) {
        return `${diffMinutes}分钟`
      }
      const diffHours = end.diff(start, 'hours')
      if (diffHours < 24) {
        return `${diffHours}小时`
      }
      const diffDays = end.diff(start, 'days')
      return `${diffDays}天`
    },
    loadData() {
      Toast.loading({
        mask: true,
        message: '加载中...'
      })
      getUser(this.$route.params.id).then(res => {
        Toast.clear()
        const data = res.data;
        if (data.code == 0) {
          this.model = data.user
          this.contactWay.mobile=this.model.mobile
          this.contactWay.wechatIds=this.model.wechatIds
        } else {
          Dialog.alert({
            title: '加载失败',
            message: data.msg
          })
        }
      })
    },
    imgClick(i) {
      ImagePreview({
        images: this.model.photoUrls,
        startPosition: i,
      })
    },
  },
  mounted() {
    this.loadData()
  },
  updated() {
    // 统一替换标签
    this.$replaceLabel(document.body, this.$store.state.label, true)
  }
}
</script>

<style lang="less" scoped>
.page {
  padding-bottom: 100px;
  .van-panel__header{
    padding:0;
  }
  .panel-info {
    .content {
      font-size: 14px;
      padding: 30px 15px 15px;

      .row {
        .cell-padding{
          padding: 0;
          .user-item {
            display: flex;
            align-items: center;
            .userMemo {
              color: #999;
            }
            .left {
              flex: 1;
              display: flex;
              .service-info {
                color: #333;
              }
              .created {
                color: #555;
                margin-bottom: 5px;
              }
              .user_head {
                position: relative;
                padding: 10px;
                .avatarFrame {
                  position: absolute;
                  top: 0;
                  left: 0;
                }
                .level {
                  position: absolute;
                  left: 50%;
                  height: 10px;
                  font-size: 10px;
                  white-space: nowrap;
                  bottom: 0px;
                  transform: translateX(-50%);
                }
              }
              .padding-left-sm div span{
                margin-right: 4px;
              }
              .recommend{
                height: 20px;
                line-height: 20px;
                font-size: 12px;
                color: #999999;
              }
            }
            .right {
              text-align: right;
              min-width: 30px;
              .total-amount {
                color: #333;
              }
            }
          }
        }
      }
    }
    .button-margin{
      margin-top: 10px;
    }
  }
  .row {
    display: flex;
    color: #333;
    margin: 10px 0;
    align-items: center;
  }
  .label {
    width: 80px;
    color: #888;
  }

  .value {
    flex: 1;
  }
  .commentBox{
    width: 100%;
    background: #fff;
    padding: 15px;
    margin-top: 20px;
    box-sizing: border-box;
  }
  .imgStyle{
    margin-left: 10px;
    flex: 0 0 15%;
    height: 0;
    padding-bottom: 15%;
    overflow: hidden;
    position: relative;
  }
  .screenshot{
    width: 100%;
    display: flex;
    align-content: flex-start;
    flex-flow: row wrap;
  }
  .screenshotImg{
    width: 100%;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  .contact-way{
    display: flex;
    margin: 5px 0;
    .wechat{
      overflow-y:auto;
      max-height: 120px;
      line-height: 21px;
      width: 80%;
      color: #333
    }
  }
}
.info{
  border: 1px solid #abdcff;;
  background-color: #f0faff;
  padding: 5px;
  border-radius: 5px;
  font-size: 12px;
  width: 90%;
  margin-left: 3%;
  margin-bottom: 3px;
  margin-top: 3px;
  display:flex;
  justify-content: space-between;
}
.warning{
  border: 1px solid #ffd77a;
  background-color: #fff9e6;
  padding: 5px;
  border-radius: 5px;
  color: red;font-size: 12px;
  width: 90%;
  margin-left: 3%;
  margin-bottom: 3px;
  margin-top: 3px;
  display:flex;
  justify-content: space-between;
}
.image-uploader {
  /deep/ .van-uploader__wrapper {
    .van-uploader__preview {
      .van-uploader__preview-delete {
        top: 0;
        right: 0;
        color: var(--primary-color);
      }
    }
  }
}
.mark-violation{
    /deep/.van-dialog__header{
      padding-top:15px;
      font-size: 16px;
    }
  .warning{
    border: 1px solid #ffd77a;
    background-color: #fff9e6;
    padding: 5px;
    border-radius: 5px;
    color: red;font-size: 12px;
    width: 90%;
    margin-left: 3%;
    margin-bottom: 3px;
    margin-top: 3px;
    display:flex;
    justify-content: space-between;
  }
  .photo{
    font-size: 14px;
    padding: 10px 16px 0;
  }
}

.lookBlack{
  .title{
    text-align: center;
    font-size: 16px;
    padding: 10px;
  }
  .line-title{
    font-size: 14px;
    padding: 10px;
  }
  .text{
    padding: 10px;
  }
  .img-box{
    padding: 0 10px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    img{
      width: 60px;
      height: 60px;
      display: block;
      margin: 0 10px 10px 0;
    }
  }
}
</style>
